export const ChangePointListPage = () => {
  return <>ChangePointListPage</>;
};
